/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ChoiceAnswerModel } from './ChoiceAnswerModel';
import type { InformationRequestChildQuestion } from './InformationRequestChildQuestion';
export type InformationRequestQuestion = {
  readonly id?: number;
  name: string;
  question_type: InformationRequestQuestion.question_type;
  options: Array<ChoiceAnswerModel>;
  description?: string | null;
  readonly answered?: boolean;
  readonly answer_display?: string | null;
  readonly children_questions?: Array<InformationRequestChildQuestion>;
};
export namespace InformationRequestQuestion {
  export enum question_type {
    TEXT = 'text',
    DATE = 'date',
    DROPDOWN = 'dropdown',
    MULTIPLE = 'multiple',
  }
}

